<!-- ============================================================== -->
<!-- Page wrapper  -->
<!-- ============================================================== -->
<div class="page-wrapper"
     style="color: #8d97ad">
  <!--[style.margin-top.px]="((layoutManager.mobileMode)?0:0) + ((!layoutManager.mobileMode && layoutManager.innerWidth<1389)?100:0)"-->

  <!-- ============================================================== -->
  <!-- Static Slider 10  -->
  <!-- ============================================================== -->
  <div class="banner-innerpage" style="background-image:url('../../assets/images/banner-bg2.jpg')">
    <div class="container">
      <!-- Row  -->
      <div class="row justify-content-center ">
        <!-- Column -->
        <div class="col-md-6 align-self-center text-center" data-aos="fade-down" data-aos-duration="1200">
          <h1 class="title">Non sai di che si tratta?</h1>
          <h6 class="subtitle op-8">Non preoccuparti, in questa pagina proveremo a chiarirti le idee</h6> </div>
        <!-- Column -->
      </div>
    </div>
  </div>
  <!-- ============================================================== -->
  <!-- End Static Slider 10  -->
  <!-- ============================================================== -->
  <!-- ============================================================== -->
  <!-- Container fluid  -->
  <!-- ============================================================== -->
  <div class="container-fluid">
    <!-- ============================================================== -->
    <!-- Feature 41  -->
    <!-- ============================================================== -->
    <div class="bg-light spacer feature41">
      <div class="container">
        <!-- Row  -->
        <div class="row justify-content-center">
          <div class="col-md-7 text-center">
            <h2 class="title">Tutto ciò che devi conoscere</h2>
            <h6 class="subtitle">I requisiti di base per apprendere in breve il funzionamento dei Trading Software</h6>
          </div>
        </div>
        <!-- Row  -->
        <div class="row m-t-40 wrap-feature41-box">
          <!-- Column -->
          <div class="col-md-4">
            <ul class="nav vtab f41-tab">
              <li class="nav-item">
                <a class="nav-link active" id="home-tab" data-toggle="tab" href="#broker" aria-controls="broker" aria-expanded="true">
                  <div class="display-5 t-icon"><i class="icon-Suitcase"></i></div>
                  <div>
                    <h5 class="m-b-0">Conto con un broker</h5>
                    <h6 class="subtitle">Noi non siamo broker, per tanto è necessario possedere un conto.</h6>
                  </div>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" aria-controls="profile">
                  <div class="display-5 t-icon"><i class="icon-Dollar-Sign"></i></div>
                  <div>
                    <h5 class="m-b-0">Trading Software</h5>
                    <h6 class="subtitle">Ciò che puoi acquistare nella piattaforma.</h6>
                  </div>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="dropdown1-tab" data-toggle="tab" href="#dropdown1" aria-controls="dropdown1">
                  <div class="display-5 t-icon"><i class="icon-Data-Center"></i></div>
                  <div>
                    <h5 class="m-b-0">VPS</h5>
                    <h6 class="subtitle">La potenza offerta dai nostri server.</h6>
                  </div>
                </a>
              </li>
            </ul>
          </div>
          <!-- Column -->
          <!-- Column -->
          <div class="col-md-7 ml-auto">
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane fade show active" id="broker" role="tabpanel" aria-labelledby="broker-tab">
                <p class="m-t-40">
                  Un <b>broker</b> ti consente di effettuare operazioni in borsa, al giorno d'oggi in modo molto semplice
                  e versatile. Quasi tutti i broker supportano <b>MetaTrader</b> come piattaforma per gestire la
                  compravendita, requisito necessario per poter usare il conto con i nostri <b>Trading Software</b>.
                  <br>I nostri servizi interagiscono automaticamete con il tuo broker grazie ai nostri server,
                  e senza il bisogno di interventi lavorano in modo completamente autonomo nel conto.<br>
                  <a routerLink="/partners">Clicca qui</a> per visionare la convenzione con il nostro broker partner Klimex.<br>
                </p>
                <img src="../../assets/images/stocks.jpg" alt="wrapkit" class="rounded img-fluid img-rounded" />
              </div>
              <div class="tab-pane fade show" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                <img src="../../assets/images/stocks2.jpg" alt="wrapkit" class="rounded img-fluid" />
                <p class="m-t-40">Un <b>Trading Software</b> (Consigliere Esperto) è un software che opera automaticamente nei mercati
                finanziari secondo un propria strategia programmata.<br>
                Questo tipo di software sono capaci di lavorare <b>24/h</b> e di gestire in modo completamente automatico le operazioni
                in borsa. <br>Sfoglia il nostro <a routerLink="/store">Store</a>.</p>
              </div>
              <div class="tab-pane fade show" id="dropdown1" role="tabpanel" aria-labelledby="drowdown1-tab">
                <p class="m-t-40">Un <b>VPS</b> (Virtual Private Server) è un server adibito all'esecuzione dei Trading Software,
                  questo è necessario per poter utilizzare questo tipo di software e i nostri <b>server</b> offrono l'esclusiva opportunità
                 di attivarlo gratuitamente associato al Consigliere Esperto.<br>
                  Questa pratica è stata apliamente semplificata da <b>AssetX</b> rendendo molto più semplice utilizzare
                 un Trading Software.</p>
                <img src="../../assets/images/server1.jpg" alt="wrapkit" class="rounded img-fluid" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ============================================================== -->
    <!-- End Feature 41  -->
    <!-- ============================================================== -->



    <!-- ============================================================== -->
    <!-- Feature 38  -->
    <!-- ============================================================== -->
    <div class="feature37 wrap-feature38-box">
      <div class="row bg-primary">
        <div class="col-lg-6 po-absolute text-right" style="padding-right: 0;height: 450px" #objCont>
          <img style="width: 650px;" [style.margin-top.px]="objCont.clientHeight/3.5" src="../../assets/images/dashboard-ic.PNG" alt="wrapkit" class="img-fluid" /> </div>
        <div class="container">
          <div class="row spacer">
            <div class="col-lg-6">
              <div class="p-20"><span class="label label-success label-rounded">Admin</span>
                <h2 class="title text-white text-uppercase">Scopri come funziona la nostra piattaforma</h2>
                <p class="text-white op-8">Impara ad utilizzare la nostra piattaforma per aggiungere i Consiglieri Esperti sul tuo conto.</p>
                <div class="row">
                  <div class="col-md-12">
                    <div class="collapse m-t-20" id="f38">
                      <div class="card card-body card-shadow text-dark">
                        <ul class="nav nav-tabs" id="myTab7" role="tablist">
                          <li class="nav-item">
                            <a class="nav-link active" id="html-tab7" data-toggle="tab" href="#html8" role="tab" aria-controls="html" aria-expanded="true">HTML</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" id="css-tab7" data-toggle="tab" href="#css8" role="tab" aria-controls="css">CSS</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ============================================================== -->
    <!-- End Feature 38  -->
    <!-- ============================================================== -->
    <br><br><br><br><br>
    <!-- ============================================================== -->
    <!-- Feature 39  -->
    <!-- ============================================================== -->
    <div class="feature39 spacer wrap-feature39-box">
      <div class="container">
        <div class="row">
          <div class="col-lg-6"><img src="../../assets/images/store.PNG" class="img-fluid" alt="icon" /></div>
          <div class="col-lg-6">
            <div class="card-body">
              <h3 class="title text-uppercase">Sfoglia il catalogo Trading Software nello <b>STORE</b></h3>
              <p class="m-t-40 m-b-40">Aggiungi i software dallo Store, sfoglia il catalogo e scegli quelli più adatti
                alla tua tecnica e aggiungili al pannello personale. Alcuni Software (con il sufffisso 'GT') sono
                riservati a chi ha il conto presso il nostro broker convenzionato, permettono di accedervi ad un
                prezzo agevolato.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="feature39 spacer wrap-feature39-box bg-light">
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <div class="card-body">
              <h3 class="title text-uppercase">Gestisci i tuoi Software e attiva le licenze nella Sezione <b>GESTIONE SOFTWARE</b></h3>
              <p class="m-t-40 m-b-40">Il pannello ti permette di gestire i software che hai aggiunto, da qui
              puoi controllare lo stato di attivazione dei Consiglieri Esperti.<br>Questo pannello ti permette inoltre
              di settare i parametri specifici per ogni software attivo, in questo passaggio potrai richiedere l'assistenza
              di un nostro Esperto che valuterà il tuo conto e la soluzione più adatta a te.</p>
            </div>
          </div>
          <div class="col-lg-6"><img style="margin-left: 50px" src="../../assets/images/gest-software.PNG" class="img-fluid" alt="wrapkit" /></div>
        </div>
      </div>
    </div>
    <div class="feature39 spacer wrap-feature39-box">
      <div class="container">
        <div class="row">
          <div class="col-lg-6"><img src="../../assets/images/vps-manager.PNG" class="img-fluid" alt="wrapkit" /></div>
          <div class="col-lg-6">
            <div class="card-body">
              <h3 class="title text-uppercase">Attiva il tuo VPS gratuito nella sezione <b>VPS</b></h3>
              <p class="m-t-40 m-b-40">Il nostro servizio VPS si connette automaticamente al tuo conto personale
                del broker, inserisci le credenziali ed attendi l'attivazione... Parti e inizia subito a
                utilizzare il sistema automatizzato!</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ============================================================== -->
    <!-- Feature 39  -->
    <!-- ============================================================== -->

  </div>
</div>
